export const initialFeedbackForm =[
    {
        question_id:1,
        question_text:'',
        category:''
    },
    {
        question_id:2,
        question_text:'',
        category:''
    },
    {
        question_id:3,
        question_text:'',
        category:''
    },
    {
        question_id:4,
        question_text:'',
        category:''
    },
    {
        question_id:5,
        question_text:'',
        category:''
    },
    {
        question_id:6,
        question_text:'',
        category:'suggestion'
    },
   
]